export const VI = {
  "Open document": "Má» tÃ i liá»u",
  "Upload file": "Cáº­p nháº­t dá»­ liá»u",
  "Drop file here to upload": "Tháº£ tá»p vÃ o ÄÃ¢y Äá» táº£i lÃªn",
  "Disc": "ÄÄ©a",
  "URL": "URL",
  "FILE": "Táº¬P TIN",
  "SIZE": "KÃCH THÆ¯á»C",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Byte",
  "Loading... Please wait.": "Táº£i vui lÃ²ng Äá»£i.",
  "Fit Width": "Vá»«a chiá»u rá»ng",
  "Fit Height": "Chiá»u cao phÃ¹ há»£p",
  "Password protected document": "TÃ i liá»u ÄÆ°á»£c báº£o vá» báº±ng máº­t kháº©u",
  "Password": "Máº­t kháº©u",
  "Open": "Má» ra",
  "Password Required": "MÃ¢Ì£t khÃ¢Ìu ÄÆ°Æ¡Ì£c yÃªu cÃ¢u",
  "Incorrect password": "máº­t kháº©u khÃ´ng ÄÃºng",
  "Error": "Lá»i",
  "Something went wrong": "ÄÃ£ xáº£y ra sá»± cá»",
  "Server is not available": "MÃ¡y chá»§ khÃ´ng cÃ³ sáºµn",
  "of": "cá»§a",
  "Please wait...": "Vui lÃ²ng chá»..."
};
